<div class="confirmation-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  
  <mat-dialog-content>
    <div class="warning-icon" *ngIf="data.type === 'warning'">
      <mat-icon>warning</mat-icon>
    </div>
    <p>{{ data.message }}</p>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onNoClick()">
      {{ data.cancelText }}
    </button>
    <button mat-raised-button color="warn" (click)="onYesClick()">
      {{ data.confirmText }}
    </button>
  </mat-dialog-actions>
</div> 